import { AfterViewInit, Directive, ElementRef, OnDestroy, inject } from '@angular/core';
import { FocusRestoreService } from '@mwe/services';

@Directive({
  selector: '[mwePreserveFocus]',
})
export class PreserveFocusDirective implements OnDestroy, AfterViewInit {
  private el = inject(ElementRef);
  private focusService = inject(FocusRestoreService);

  ngOnDestroy(): void {
    const activeEl = document.activeElement as HTMLElement;

    if (activeEl && this.el.nativeElement.contains(activeEl) && activeEl.hasAttribute(this.focusService.attrKey)) {
      this.focusService.storeFocusedId(activeEl.getAttribute(this.focusService.attrKey));
    }
  }

  ngAfterViewInit(): void {
    const idToFocus = this.focusService.getAndClearFocusedId();
    if (idToFocus) {
      const elToFocus = this.el.nativeElement.querySelector(`[${this.focusService.attrKey}="${idToFocus}"]`);
      elToFocus?.focus();
    }
  }
}
